export default class TagBaseService {}
